import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from 'src/store';
import { getUserAutoSuggestions, updateUser } from 'src/store/user/action';
import { User } from 'src/store/user/types';
import LoadingSpinner from 'src/components/utils/LoadingSpinner/LoadinSpinner';
import { IconPaths } from 'src/icons';
import CreateNewUser from './CreateNewUser/CreateNewUser';

interface Props {
  updateUser: typeof updateUser;
  getAutoSuggestions: typeof getUserAutoSuggestions;
  users: User[];
  loading: boolean;
  error: any;
  dispatch: any;
}

interface State {
  searchValue: string;
  selected?: string;
  value: any;
}

class UserManagement extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      searchValue: '',
      selected: undefined,
      value: undefined
    };

    this.onChange = this.onChange.bind(this);
    this.onClick = this.onClick.bind(this);
    this.setInit = this.setInit.bind(this);
    this.onChangeUser = this.onChangeUser.bind(this);
    this.onChangeType = this.onChangeType.bind(this);
    this.onSave = this.onSave.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  onClick(e: any) {
    e.preventDefault();
    this.props.getAutoSuggestions('', this.state.searchValue);
  }

  onChange(e: React.ChangeEvent<HTMLInputElement>) {
    const searchValue = e.target.value;
    this.setState({ searchValue });
  }

  setInit(user: User) {
    this.setState({ value: { ...user } });
  }

  public render() {
    const { users, loading } = this.props;
    return (
      <div className="container">
        <div className="col-lg-8 centered">
          <h2>Benutzer editieren</h2>
          <form style={{ marginBottom: '40px' }}>
            <input
              style={{ width: 'calc(100% - 100px)' }}
              type="text"
              value={this.state.searchValue}
              onChange={this.onChange}
            />
            <button onClick={this.onClick}>Suche</button>
          </form>
        </div>
        <div className="col-12 centered" style={{ marginBottom: '20px' }}>
          <LoadingSpinner pending={loading} />
          {users && (
            <table className="manageTable">
              <thead>
                <tr>
                  <th />
                  <th>Name</th>
                  <th>Benutzername</th>
                  <th>Email</th>
                  <th>Passwort</th>
                  <th />
                  <th />
                </tr>
              </thead>

              <tbody>
                {users &&
                  users.map((user: User) => {
                    return this.userView(user);
                  })}
              </tbody>
            </table>
          )}
        </div>
        <div style={{ marginTop: '80px' }}>
          <h2>Neuen Benutzer erstellen</h2>
          <CreateNewUser showHeader={true} />
        </div>
      </div>
    );
  }

  onEdit(user: User) {
    this.setState(
      prevState => {
        return {
          ...prevState,
          selected: user.id,
          value: user
        };
      },
      () => {
        console.log(this.state);
      }
    );
  }

  onChangeUser(e: React.ChangeEvent<HTMLInputElement>) {
    const inputValue = e.target.value;
    const name = e.target.name;

    this.setState(prevState => {
      return {
        ...prevState,
        value: {
          ...prevState.value,
          [name]: inputValue
        }
      };
    });
  }

  onCancel() {
    this.setState({ selected: undefined });
  }

  onSave() {
    this.props.updateUser(this.state.value);
    this.onCancel();
  }

  onChangeType(event: any) {
    const selected = event.target.value;

    this.setState(prevState => {
      return {
        ...prevState,
        value: {
          ...prevState.value,
          role: {
            name: selected
          }
        }
      };
    });
  }

  userEditView(user: User) {
    return (
      this.state.value && (
        <tr key={user.id} className="editing">
          <td>
            <button onClick={this.onSave} className="noStyle">
              <img src={IconPaths['save-icon']} title="Speichern" />
            </button>
            <button onClick={this.onCancel} className="noStyle">
              <img src={IconPaths['cancel-icon']} title="Abbrechen" />
            </button>
          </td>
          <td>
            <input
              autoComplete="off"
              type="text"
              value={this.state.value.name}
              name="name"
              onChange={this.onChangeUser}
            />
          </td>
          <td>
            <input
              autoComplete="off"
              type="text"
              value={this.state.value.username}
              name="username"
              onChange={this.onChangeUser}
            />
          </td>
          <td>
            <input
              autoComplete="off"
              type="text"
              value={this.state.value.email}
              name="email"
              onChange={this.onChangeUser}
            />
          </td>
          <td>
            <input
              autoComplete="off"
              type="text"
              value={this.state.value.password}
              name="password"
              onChange={this.onChangeUser}
            />
          </td>
        </tr>
      )
    );
  }

  userView(user: User) {
    if (this.state.selected === user.id) {
      return this.userEditView(user);
    } else {
      return (
        <tr key={user.id}>
          <td>
            <img
              className="pointer"
              src={IconPaths['edit-icon']}
              onClick={this.onEdit.bind(this, user)}
            />
          </td>
          <td>{user.name}</td>
          <td>{user.username}</td>
          <td>{user.email}</td>
          <td />
        </tr>
      );
    }
  }
}

const mapStateToProps = ({ users }: ApplicationState) => ({
  users: users.suggestions,
  loading: users.loading,
  error: users.errors
});

const mapDispatchToProps = (dispatch: any) => ({
  getAutoSuggestions: (type: string, searchString: string) =>
    dispatch(getUserAutoSuggestions(searchString, type)),
  updateUser: (user: User) => dispatch(updateUser(user))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserManagement);



// WEBPACK FOOTER //
// ./src/pages/Management/UserManagement/UserManagement.tsx